import { render, staticRenderFns } from "./Nomenclature.vue?vue&type=template&id=7afd9ea3&"
import script from "./Nomenclature.vue?vue&type=script&lang=js&"
export * from "./Nomenclature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports